import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    tournaments: [],
    selectedTournament: null,
    registrations: [],
    matches: [],
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
    },
};

const tournamentSlice = createSlice({
    name: 'tournament',
    initialState,
    reducers: {
        setTournaments: (state, action) => {
            state.tournaments = action.payload;
        },
        setSelectedTournament: (state, action) => {
            state.selectedTournament = action.payload;
        },
        setRegistrations: (state, action) => {
            state.registrations = action.payload;
        },
        setMatches: (state, action) => {
            state.matches = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        addTournament: (state, action) => {
            state.tournaments.unshift(action.payload);
        },
        updateTournament: (state, action) => {
            const index = state.tournaments.findIndex((t) => t.id === action.payload.id);
            if (index !== -1) {
                state.tournaments[index] = action.payload;
            }
        },
        removeTournament: (state, action) => {
            state.tournaments = state.tournaments.filter((t) => t.id !== action.payload);
        },
        updateRegistrationStatus: (state, action) => {
            const { id, status } = action.payload;
            const reg = state.registrations.find((r) => r.id === id);
            if (reg) {
                reg.status = status;
            }
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const {
    setTournaments,
    setSelectedTournament,
    setRegistrations,
    setMatches,
    setPagination,
    setLoading,
    setError,
    addTournament,
    updateTournament,
    removeTournament,
    updateRegistrationStatus,
    clearError,
} = tournamentSlice.actions;

export default tournamentSlice.reducer;
